import { RemoveDeviceFromOrganisationQueryArg } from '../types/query-arg';
import { RemoveDeviceFromOrganisationQueryBody } from '../types/query-body';

export const removeDeviceFromOrganisationQueryBody = ({
  device: { id },
}: RemoveDeviceFromOrganisationQueryArg): RemoveDeviceFromOrganisationQueryBody => ({
  actionType: 'RemoveOrganisation',
  id,
});
